module.exports = __webpack_public_path__ + "img/Z60Q_11.4af032d3.jpg";